<script>
import Buttons from '@components/buttons.vue'
import CategoryForm from '@components/announcement/category/category-form'

export default {
  name: 'AnnouncementEdit',
  components: { CategoryForm, Buttons },
  props: {
    category: {
      type: Object,
      required: true,
    },
    actionClicked: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      form: Object.assign({}, this.category),
      buttons: [
        {
          name: 'Update',
          type: 'submit',
          class: 'btn-primary px-4',
          method: (form) => {
            this.$store.dispatch('category/updateCategory', form)
            this.actionClicked('Home')
          },
        },
        {
          name: 'Cancel',
          type: 'submit',
          class: 'btn-secondary ml-1',
          method: () => {
            this.actionClicked('Home')
          },
        },
      ],
    }
  },
  methods: {
    canSubmit(isInvalid) {
      this.buttons[0].disabled = isInvalid
    },
  },
}
</script>
<template>
  <div class="col col-lg-7 create-country-wrap p-0">
    <CategoryForm :form="form" :can-submit="canSubmit">
      <div slot="submit" class="form-buttons text-right">
        <Buttons :buttons="buttons" :form="form" />
      </div>
    </CategoryForm>
  </div>
</template>
